
export class SitnGoConfigVO {
    public ignFull: boolean = false;
    // bereits geatartete sit'n'gos ein/ausblenden
    public ignRun: boolean = false;
    public input: number = 0;
    public sort: number = 0;
    public up: number = 0;
    public down: number = 0;
}
